import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PublicHeader } from "@/components/public/PublicHeader";
import { Hero } from "@/components/public/Hero";
import { ServicesSection } from "@/components/public/ServicesSection";
import { InstitutionalSection } from "@/components/public/InstitutionalSection";
import { ExtraSections } from "@/components/public/ExtraSections";
import { ContactSection } from "@/components/public/ContactSection";
import { PublicFooter } from "@/components/public/PublicFooter";
import { LeadFormDialog } from "@/components/public/LeadFormDialog";

export default function HomePage() {
  const [site, setSite] = useState({ center: {}, sections: [] });
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [assets, setAssets] = useState({});
  const [form, setForm] = useState({ open: false, mode: "info", serviceId: "" });

  useEffect(() => {
    api.get("/public/site").then((r) => setSite(r.data)).catch(() => {});
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/public/service-categories").then((r) => setCategories(r.data)).catch(() => {});
    api.get("/public/assets").then((r) => setAssets(r.data)).catch(() => {});
  }, []);

  const openForm = useCallback((mode, serviceId = "") => setForm({ open: true, mode, serviceId }), []);
  const center = site.center || {};

  return (
    <div className="min-h-screen overflow-x-hidden bg-white text-[#0B2545]" data-testid="public-home">
      <PublicHeader center={center} onAgendar={() => openForm("agendar")} />
      <main>
        <Hero center={center} image={assets.hero} stock={assets.stock?.hero} framing={assets.framing} services={services} onOpen={openForm} />
        <ServicesSection services={services} categories={categories} onOpen={openForm} />
        <InstitutionalSection assets={assets} />
        <ExtraSections sections={site.sections} />
        <ContactSection center={center} />
      </main>
      <PublicFooter center={center} />
      <LeadFormDialog
        open={form.open}
        mode={form.mode}
        serviceId={form.serviceId}
        services={services}
        categories={categories}
        center={center}
        onOpenChange={(open) => setForm((f) => ({ ...f, open }))}
        onModeChange={(mode) => setForm((f) => ({ ...f, mode }))}
      />
    </div>
  );
}
